import React from 'react';

export default class Card extends React.Component {
}